/* src/app/shared/components/bottom-navigation/bottom-navigation.component.scss */
.footer {
  min-height: 56px;
  display: flex;
  justify-content: space-evenly;
  box-shadow: 0px -5px 12px 19px rgba(27, 28, 29, 0.03);
  background: var(--ion-background-color);
  padding-bottom: 8px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
ion-icon {
  color: rgba(10, 11, 13, 0.15);
  font-size: 24px;
}
:host-context(body[data-theme=dark]) ion-icon {
  color: rgba(243, 249, 255, 0.15);
  font-size: 24px;
}
ion-button {
  height: 36px;
}
ion-button.active-footer-btn {
  --padding-start: 11px;
  --padding-end: 11px;
  --background: var(--wb-light-gray);
}
.active-footer-icon {
  color: #0A0B0D;
}
:host-context(body[data-theme=dark]) .active-footer-icon {
  color: rgba(243, 249, 255, 0.75);
}
.footer-icon {
  height: 24px;
}
.footer-icon-active {
  height: 20px;
}
.footer-text {
  color: rgba(10, 11, 13, 0.75);
}
.footer-text-dark {
  color: rgba(243, 249, 255, 0.75);
}
.small-padding {
  --padding-start: 2px;
  --padding-end: 2px;
}
/*# sourceMappingURL=bottom-navigation.component.css.map */
